// src/components/Dashboard/CoachDashboard/QuickActionsBar.jsx
// Quick action buttons for common coach tasks

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaClipboardCheck, FaTrophy, FaPlay, FaChartLine, 
  FaComments, FaBolt
} from 'react-icons/fa';
import AwardAssignmentModal from '../../Awards/AwardAssignmentModal';
import styles from './QuickActionsBar.module.css';

const QuickActionsBar = ({ program, userProfile }) => {
  const navigate = useNavigate();
  const [showAwardModal, setShowAwardModal] = useState(false);

  const handleTakeAttendance = () => {
    if (program) {
      navigate(`/program/${program._id}/events`);
    }
  };

  const handleGiveAward = () => {
    setShowAwardModal(true);
  };

  const handleStartEvent = () => {
    if (program) {
      navigate(`/program/${program._id}/events`);
    }
  };

  const handleViewStats = () => {
    if (program) {
      navigate(`/program/${program._id}/teams`);
    }
  };

  const handleMessageTeam = () => {
    // TODO: Implement team messaging
    // TODO: Implement team messaging
  };

  const actions = [
    {
      id: 'attendance',
      icon: FaClipboardCheck,
      label: 'Take Attendance',
      onClick: handleTakeAttendance,
      color: '#10b981'
    },
    {
      id: 'award',
      icon: FaTrophy,
      label: 'Give Award',
      onClick: handleGiveAward,
      color: '#fbbf24'
    },
    {
      id: 'start',
      icon: FaPlay,
      label: 'Start Event',
      onClick: handleStartEvent,
      color: '#ef4444'
    },
    {
      id: 'stats',
      icon: FaChartLine,
      label: 'View Stats',
      onClick: handleViewStats,
      color: '#8b5cf6'
    },
    {
      id: 'message',
      icon: FaComments,
      label: 'Message Team',
      onClick: handleMessageTeam,
      color: '#3b82f6'
    }
  ];

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <FaBolt className={styles.headerIcon} />
          <h3 className={styles.headerTitle}>Quick Actions</h3>
        </div>

        <div className={styles.actionsGrid}>
          {actions.map(action => (
            <button
              key={action.id}
              className={styles.actionBtn}
              onClick={action.onClick}
              style={{ '--action-color': action.color }}
            >
              <div className={styles.actionIcon}>
                <action.icon />
              </div>
              <span className={styles.actionLabel}>{action.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Award Assignment Modal */}
      {showAwardModal && program && (
        <AwardAssignmentModal
          isOpen={showAwardModal}
          onClose={() => setShowAwardModal(false)}
          programId={program._id}
          programSport={program.sport}
          onAwardCreated={() => {
            setShowAwardModal(false);
          }}
        />
      )}
    </>
  );
};

export default QuickActionsBar;

